<section
  class="p-10 bg-ayr-yellow-200 dark:bg-ayr-grey-1000 text-ayr-black dark:text-ayr-white"
>
  <div
    class="flex max-w-960 justify-between m-auto flex-col items-center gap-4 sm:flex-row"
  >
    <h2 class="text-27 lg:text-37 font-bold md:flex items-center gap-2">
      @if (!isDarkMode) {
        <img
          class="inline w-16 lg:w-auto"
          width="100px"
          height="40px"
          src="https://storage.googleapis.com/weayr-assets-non-prod/images/sidebar/images/ayr-logo.svg"
          alt="Ayr logo"
          loading="lazy"
        />
      }

      @if (isDarkMode) {
        <img
          class="inline w-16 lg:w-auto"
          width="100px"
          height="40px"
          src="https://storage.googleapis.com/weayr-assets-non-prod/images/sidebar/images/ayr-logo white.svg"
          alt="Ayr logo"
          loading="lazy"
        />
      }

      <span class=""> {{ "businesses.ayr-in-my.in" | translate }} </span>
      @if (!isCompany) {
        <span class="ayr-underline dark:text-shadow">{{
          "cities.ayr-in-my.city" | translate
        }}</span>
      }
      @if (isCompany) {
        <span class="ayr-underline dark:text-shadow">{{
          "businesses.ayr-in-my.company" | translate
        }}</span>
      }
    </h2>

    <a
      href="mailto: contact@ayrneutral.com"
      class="text-center font-bold px-5 py-5 rounded-full bg-ayr-green-500 hover:bg-ayr-green-800 cursor-pointer duration-200 text-15 lg:text-18 text-white"
    >
      {{ "cities.schedule-button.schedule-meeting" | translate }}
    </a>
  </div>
</section>
